module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8bc7ca67021e0ae70e918543b309e810.png";